<template>
    <div>
        <Header :data_status="data_status"></Header>
        <div>
            <div class="card-block" v-show="data_status != 'loading'">
                <div class="inline" justify="between" valign="center">
                    <h1>Тип купона #{{ $route.params.id }}<router-link class="button _free _second" to="/coupon_type">К списку</router-link></h1>
                    <div class="button _free" @click="generate()">Сгенерировать</div>
                </div>
                <form class="card">
                    <div class="inline">
                        <div class="grid">
                            <h3>Купон:</h3>
                            <div class="form-item text-item">
                                <label for="type">Тип</label>
                                <input type="text" id="type" class="text-input" v-model="data.type" />
                                <p>{{ data.type_text }}</p>
                            </div>
                            <div class="form-item checkbox">
                                <input type="checkbox" id="enabled" v-model="data.active" />
                                <label for="enabled">Активный</label>
                            </div>
                            <div class="text-item">
                                <span>Дата создания</span>
                                <p>{{ data.ctime }}</p>
                            </div>

                            <div class="text-item" v-if="data.date_start">
                                <span>Дата начала действия</span>
                                <DatePicker :value.sync="data.date_start"></DatePicker>
                            </div>

                            <div class="text-item" v-if="data.date_end">
                                <span>Дата окончания действия</span>
                                <DatePicker :value.sync="data.date_end"></DatePicker>
                            </div>

                            <div class="form-item checkbox">
                                <input type="checkbox" id="onetime" v-model="data.one_time" />
                                <label for="onetime">Одноразовый</label>
                            </div>
                            <div class="form-item">
                                <label for="timesmax">Макс. кол-во использований</label>
                                <input type="text" id="timesmax" class="text-input" v-model="data.times_limit" />
                            </div>
                        </div>
                        <div class="grid">
                            <h3>Скидка:</h3>
                            <div class="form-item">
                                <label for="discount_type">Тип скидки</label>
                                <select id="discount_type" class="_wide" v-model="data.discount_type" @change="checkDiscount()">
                                    <option value="1">Процент</option>
                                    <option value="2">Сумма</option>
                                </select>
                            </div>
                            <div class="form-item">
                                <label for="max">Максимум</label>
                                <input type="text" id="max" class="text-input" v-model="data.discount_max" />
                            </div>
                            <div class="form-item">
                                <label for="current">Значение скидки</label>
                                <input type="text" id="current" class="text-input" v-model="data.discount_value" @blur="checkDiscount()" />
                            </div>
                        </div>
                    </div>
                </form>
                <div class="submit button _free" v-show="showButton" @click="update()">Сохранить</div>
            </div>
            <div class="page-load" v-show="data_status == 'loading'">
                <div class="inline" valign="center">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import DatePicker from '@/components/DatePicker.vue'

    export default {
        components: {
            Header,
            DatePicker
        },
        data () {
            return {
                data: {},
                data_backup: false,
                data_status: 'init',
                status_request: '',
            }
        },
        computed: {
            showButton () {
                if (JSON.stringify(this.data) == this.data_backup) {
                    return false
                }
                return true
            }
        },
        created () {
            this.getData()
        },
        methods: {
            checkDiscount () {
                if (this.data.discount_type == 1 && this.data.discount_value > 100) this.data.discount_value = 100
            },
            generate () {
                return new Promise((resolve, reject) => {
                    let json = JSON.stringify({type: this.data.type})
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/coupon', json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then((resp) => {
                        this.$router.push('/coupon/' + resp.data.response.id)
                        resolve()
                    }).catch(() => {
                        this.status_request = ''
                        let msg = {
                            message: 'Ошибка при генерации купона',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            savedata () {
                this.data_backup = JSON.stringify(this.data)
            },
            getData () {
                return new Promise((resolve) => {
                    this.data_status = 'loading'
                    this.axios.get('api/admin/v2/coupon_type/' + this.$route.params.id)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.data_status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/coupon_type')
                        })
                })
            },
            update () {
                let json = JSON.stringify(this.data)
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/coupon_type/' + this.$route.params.id, json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(() => {
                        this.status_request = ''
                        this.savedata()
                        let msg = {
                            message: 'Данные обновлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.status_request = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
        }
    }
</script>
